import {
  OfferTransactionThread,
  OfferTransactionThreadVariables,
} from "_graphql/mutation/__generated__/OfferTransactionThread";

import { offerTransactionThread } from "_graphql/visal/mutations/publish-offer";
import { useQuery } from "@apollo/client";

export const useParticipationThread = (
  variables?: OfferTransactionThreadVariables
) => {
  const { data, ...rest } = useQuery<
    OfferTransactionThread,
    OfferTransactionThreadVariables
  >(offerTransactionThread, {
    variables: variables,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
  });

  return {
    thread: data?.offerTransactionThread || [],
    ...rest,
  };
};
